import api from "PFCore/api";
import { decamelizeDesiredKeys } from "PFCore/helpers/decamelize_desired_keys";
import { Collection, Id, RefreshedActivity } from "PFTypes";

export type RefreshMatchingActivityParams = {
  activityId: Id;
  profileId: Id;
};

export type RefreshMatchingActivityResponse = Collection<
  RefreshedActivity[],
  {
    status: "ready" | "matches_outdated";
    matchedDictionaries?: {
      direct: string[];
      indirect: string[];
      related: string[];
    };
    timestamps: {
      updatedAt: string | null;
      synchronizedAt: string | null;
      matchedAt: string | null;
      prefilteredAt: string | null;
      availabilityMatchedAt: string | null;
      matchingFinishedAt: string | null;
      requestedAt: string | null;
      completedAt: string | null;
    };
  }
>;

export const refreshMatchingActivity = ({
  activityId,
  profileId
}: RefreshMatchingActivityParams): Promise<RefreshMatchingActivityResponse> =>
  api({
    url: `matching_activities/${activityId}/refresh`,
    method: "POST",
    data: {
      profileId
    }
  }).then((res) => decamelizeDesiredKeys<RefreshMatchingActivityResponse>(res, ["entries"])); // TODO: [PROF-5746] Remove decamelizeKeys when app is camelized
